import { type ReactElement, type ReactNode } from 'react'

export const nfcLandingPageTextAccentNowrap = (
  text: ReactNode[],
): ReactElement => (
  <span className="whitespace-nowrap font-medium italic text-dark-accent">
    {text}
  </span>
)

export const nfcLandingPageTextAccent = (text: ReactNode[]): ReactElement => (
  <span className="font-medium italic text-dark-accent">{text}</span>
)

export const nfcLandingPageNoWrap = (text: ReactNode[]): ReactElement => (
  <span className="whitespace-nowrap">{text}</span>
)
